import { lmsClient } from "api";

const VirtualAccountService = {};

// VirtualAccountController's search action actually binds
// bankaccountid/bankaccountname (confirmed from the controller source) —
// NOT virtualaccountid/virtualaccountname, which is what the old
// finstrust_lms source incorrectly assumed and would have silently
// no-op'd any filtering.
VirtualAccountService.getVirtualAccountList = function (data) {
  const params = new URLSearchParams();
  params.append("bankaccountid", data?.bankaccountid || "");
  params.append("bankaccountname", data?.bankaccountname || "");

  return lmsClient({
    url: `/lm_virtual_account/search?${params.toString()}`,
    method: "get",
  });
};

export default VirtualAccountService;
